let timeoutId = null;

const getIntervalSeconds = (timestamp) => {
  const msFromNow = (new Date() - new Date(timestamp));

  switch (false) {
    case (!(msFromNow < 60000)): return 5000;
    case (!(msFromNow < 120000)): return 20000;
    default: return 60000;
  }
};

const applyRelativeTimeAgo = (el) => {
  const timestamp = el.getAttribute("data-timestamp");

  // configure moment thresholds to display 'x seconds' between 5 and 55s
  const m = moment;
  m.relativeTimeThreshold('s', 55);
  m.relativeTimeThreshold('ss', 5);

  const rel_time = m(timestamp).parseZone().fromNow();
  el.innerText = rel_time;

  return timestamp;
};

const render = () => {
  // Clear any intervals that have previously been set if new content is added to the page
  if (!!timeoutId) { clearInterval(timeoutId); }

  let lowestIntervalMs = 60000; // 60s default
  const timeElements = document.querySelectorAll(
    "[data-behavior='localized-relative-time-ago']"
  );

  _.each(timeElements, function(el) {
    const elTimestamp = applyRelativeTimeAgo(el);

    // Update interval timer with lowest required ms
    const elIntervalMs = getIntervalSeconds(elTimestamp);
    if (elIntervalMs < lowestIntervalMs) { return lowestIntervalMs = elIntervalMs; }
  });

  return timeoutId = setTimeout(render.bind(this), lowestIntervalMs);
};

export default render;



// WEBPACK FOOTER //
// ./app/javascript/app/utils/formatRelativeDatetimes.js